import { createFileRoute } from '@tanstack/react-router';
import { GeneralTopic } from '../screens/company/topics/GeneralTopic';

export const Route = createFileRoute('/t/$tenant/settings/company/general')({
  component: GeneralTopic,
});
